<template>
    <div class='deployWrap'>

        <el-card>
            <div slot="header">
                <h1>构建 {{depluyForm.id}} 发布人: {{depluyForm.user_cn_name}} ({{depluyForm.start_time}})</h1>
                <p>启动时间:{{depluyForm.now_start_time}}天</p>
                <p>构建时间:{{depluyForm.duration |  getDuration() }}</p>
            </div>

            <el-table :data="depluyForm.data" style="width: 100%" border>
                <el-table-column label="参数名" prop="cname"></el-table-column>
                <el-table-column label="参数值" prop="value"></el-table-column>
            </el-table>

        </el-card>

    </div>
</template>

<script>
    import services from '../../cicd.services'
    export default {
        data() {
            return {
                tableData: [],
                depluyForm: {},
            }
        },

        watch: {
            selfId(newVal) {
                this.getPublishedInfo(newVal)

            }
        },

        computed: {
            params() {
                return this.$route.params
            },
            selfId() {
                return this.params.selfId
            }
        },

        created() {
            this.getPublishedInfo(this.selfId)
        },

        methods: {
            // 获取发布信息
            getPublishedInfo(id) {
                services.getSingleDeployDetailedInfo({id})
                    .then(res => this.depluyForm = res)
                    .catch(err => this.$message.error(err.message))
            }

        }
    }
</script>

<style lang='scss' scoped>
    .deployWrap {
        h1 {
            font-size: 24px;
            padding: 20px 0;
        }
        p {
            line-height: 20px;
        }
    }
</style>
